import { Socket } from 'socket.io-client';

class SocketService {
  private static socket: Socket | null = null;

  static setSocket(socket: Socket): void {
    this.socket = socket;
  }

  static getSocket(): Socket | null {
    return this.socket;
  }

  static emit(event: string, data: any): void {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  static on(event: string, callback: (data: any) => void): void {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  static off(event: string, callback?: (data: any) => void): void {
    if (this.socket) {
      if (callback) {
        this.socket.off(event, callback);
      } else {
        this.socket.off(event);
      }
    }
  }

  static disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

export { SocketService };





